export default __webpack_public_path__ + "static/media/Roboto-Black.14cae30d.woff";